import { HttpHeaders } from '@angular/common/http';

export class Library {
  // public static readonly API_DOMAIN = window.location.origin + '/prox';
  // public static readonly API_DOMAIN = 'https://paypiere.rampiere.com/prox';
  // public static readonly API_DOMAIN = 'https://payroll.rampiere.com';
  // public static readonly API_DOMAIN = 'https://paypieredemo.myrampiere.com';
  // public static readonly API_DOMAIN = 'https://erp.mhfoodcorp.com';
  public static readonly API_DOMAIN = 'https://172.10.0.148';
  // public static readonly API_DOMAIN = 'https://192.168.1.11:8443';

  // TEST LOCALHOST
  public static readonly API_ENDPOINT = Library.API_DOMAIN + '/services/api/';

  public static readonly STORAGE_KEY = 'webStore';
  public static readonly CURRENT_COUNTRY_ID = 278;
}

export const HEADERS = new HttpHeaders();
HEADERS.append('Accept', 'application/json, text/plain');
HEADERS.append('Content-Type', 'application/json, text/plain');
HEADERS.append('Access-Control-Allow-Origin', '*');
HEADERS.append('Access-Control-Allow-Headers', 'Origin, Content-Type, Accept, Authorization, ApplicationId');
HEADERS.append('Access-Control-Allow-Methods', 'GET, POST, PUT, DELETE, OPTIONS, HEAD');
HEADERS.append('Access-Control-Allow-Credentials', 'true');
HEADERS.append('Accept-Encoding', 'gzip');

export const OPTIONS = { headers: HEADERS };